import React from 'react';
import { 
  TextField, FormControl, InputLabel, Select, MenuItem, Button 
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const OpportunityFilters = ({
  desktop,
  mobile,
  searchTerm,
  setSearchTerm,
  filters,
  setFilters,
  opportunities,
  navigate,
  setMobileFiltersOpen,
  showTypeSelectionDialog
}) => {
  const categories = ['all', ...new Set(opportunities.map(opp => opp.category).filter(Boolean))];
  const locations = ['all', ...new Set(opportunities.map(opp => opp.location).filter(Boolean))];
  const types = ['all', 'oferta', 'demanda'];
  const publishTypes = ['all', 'Servicio', 'Bien/Producto'];

  return (
    <>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        placeholder="Buscar..."
        InputProps={{
          startAdornment: <SearchIcon color="action" fontSize="small" />
        }}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{
          mb: 2,
          '& .MuiOutlinedInput-root': {
            borderRadius: '6px'
          }
        }}
      />
      
      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel>Tipo de publicación</InputLabel>
        <Select
          value={filters.publishType}
          onChange={(e) => setFilters({...filters, publishType: e.target.value})}
          label="Tipo de publicación"
        >
          {publishTypes.map(type => (
            <MenuItem key={type} value={type} sx={{ fontSize: '0.875rem' }}>
              {type === 'all' ? 'Todos los tipos' : type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel>Tipo</InputLabel>
        <Select
          value={filters.type}
          onChange={(e) => setFilters({...filters, type: e.target.value})}
          label="Tipo"
        >
          {types.map(type => (
            <MenuItem key={type} value={type} sx={{ fontSize: '0.875rem' }}>
              {type === 'all' ? 'Todos los tipos' : 
               type === 'oferta' ? 'Ofertas' : 'Demandas'}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel>Categoría</InputLabel>
        <Select
          value={filters.category}
          onChange={(e) => setFilters({...filters, category: e.target.value})}
          label="Categoría"
        >
          {categories.map(cat => (
            <MenuItem key={cat} value={cat} sx={{ fontSize: '0.875rem' }}>
              {cat === 'all' ? 'Todas las categorías' : cat}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
        <InputLabel>Ubicación</InputLabel>
        <Select
          value={filters.location}
          onChange={(e) => setFilters({...filters, location: e.target.value})}
          label="Ubicación"
        >
          {locations.map(loc => (
            <MenuItem key={loc} value={loc} sx={{ fontSize: '0.875rem' }}>
              {loc === 'all' ? 'Todas las ubicaciones' : loc}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
      {desktop && (
        <>
          <Button 
            fullWidth
            variant="outlined"
            size="small"
            sx={{ 
              borderColor: '#0488AF',
              color: '#0488AF',
              fontSize: '0.875rem',
              '&:hover': { 
                borderColor: '#03779C',
                backgroundColor: 'rgba(4, 136, 175, 0.04)'
              }
            }}
            onClick={() => {
              setSearchTerm('');
              setFilters({
                category: 'all',
                location: 'all',
                type: 'all',
                publishType: 'all'
              });
            }}
          >
            Limpiar filtros
          </Button>

          <Button 
            fullWidth
            variant="contained"
            size="small"
            sx={{ 
              mt: 1,
              background: '#0488AF',
              color: 'white',
              fontSize: '0.875rem',
              '&:hover': { 
                background: '#071D3A'
              }
            }}
            onClick={() => navigate('/my-services')}
          >
            Mis Publicaciones
          </Button>

          <Button 
            fullWidth
            variant="contained"
            size="small"
            sx={{ 
              mt: 1,
              background: '#1BBB55',
              color: 'white',
              fontSize: '0.875rem',
              '&:hover': { 
                background: '#A01B43'
              }
            }}
            onClick={showTypeSelectionDialog}
          >
            Crear Publicación
          </Button>
        </>
      )}
      
      {mobile && (
        <>
          <Button 
            fullWidth
            variant="contained"
            size="small"
            sx={{ 
              background: '#0488AF',
              color: 'white',
              mb: 1,
              fontSize: '0.875rem',
              '&:hover': { 
                background: '#03779C'
              }
            }}
            onClick={() => setMobileFiltersOpen(false)}
          >
            Aplicar filtros
          </Button>
          
          <Button 
            fullWidth
            variant="outlined"
            size="small"
            sx={{ 
              borderColor: '#0488AF',
              color: '#0488AF',
              fontSize: '0.875rem',
              '&:hover': { 
                borderColor: '#03779C',
                backgroundColor: 'rgba(4, 136, 175, 0.04)'
              }
            }}
            onClick={() => {
              setSearchTerm('');
              setFilters({
                category: 'all',
                location: 'all',
                type: 'all',
                publishType: 'all'
              });
            }}
          >
            Limpiar filtros
          </Button>
        </>
      )}
    </>
  );
};

export default OpportunityFilters;